import { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import getInitialState from 'Common/utils/getInitialState'

// CONTEXT OBJECTS
const SignInState = createContext()

SignInState.displayName = 'SubscriptionState'

// CUSTOM HOOK
function useSignInContext() {
  const state = useContext(SignInState)

  if (state === undefined)
    throw new Error('useSignInContext must be used within a SignInProvider')
  return state
}

function _formatState(initialState) {
  const {
    hidden_fields: hiddenFields,
    initial_values: initialValues,
    google_sso_url: googleSSOUrl,
    clever_sso_url: cleverSSOUrl,
    ...rest
  } = initialState

  return {
    ...rest,
    hiddenFields,
    initialValues,
    googleSSOUrl,
    cleverSSOUrl,
  }
}

// CONTEXT PROVIDER
function SignInProvider({ children }) {
  const initialState = _formatState(getInitialState())

  return (
    <SignInState.Provider value={initialState}>{children}</SignInState.Provider>
  )
}

SignInProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { SignInProvider, useSignInContext }
